import { cx } from 'class-variance-authority';
import { HTMLAttributes } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
    /** @deprecated */
    css?: any;

    flat?: boolean;
}

export default function Card({ css, className, children, flat, ...props }: CardProps) {
    return (
        <div className={cx(flat ? 'tw-card-flat' : 'tw-card-bordered', className)} {...props}>
            {children}
        </div>
    );
}
